import { AccountTriageState } from '@interfaces/state';
import { createSelector } from '@ngrx/store';
import { selectAllTransactions } from '@store/selectors/transaction-state/transaction-state.selectors';

import * as fromFeature from '../../reducers';

export const selectAccountTriageState = createSelector(
  fromFeature.getAccountTriageState,
  (state: AccountTriageState) => state,
);

export const selectIsSpousalMultiFlow = createSelector(
  selectAllTransactions,
  (state: fromFeature.TransactionState[]) => {
    return state.some((transaction) => transaction.accountTriage.isSpouse === 'YES');
  },
);
